export default function StatusIndicator({ label, tone = 'neutral', detail }) {
  return (
    <span className={`status-indicator status-${tone}`}>
      <span className="status-dot" aria-hidden="true" />
      <span>
        <span className="status-label">{label}</span>
        {detail && <span className="status-detail">{detail}</span>}
      </span>
    </span>
  )
}
